import { useSurveyConfig } from 'app/core/survey-config';
import { Button } from 'app/shared/components';
import React from 'react';

function Reload() {
  const { wording } = useSurveyConfig();
  return (
    <Button
      color="primary"
      onClick={() => window.location.reload()}
      style={{ width: '100%' }}
    >
      {wording.common.action.restart}
    </Button>
  );
}

export default Reload;
